module.exports = __webpack_public_path__ + "img/account-info-bg.a892ceb2.png";